module.exports = __webpack_public_path__ + "static/media/conway_family.6fa9d405.jpg";